import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "jubasmash_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, opts = {}) => {
    setItems((prev) => {
      const key = `${opts.selected_date || ""}|${opts.selected_size || ""}|${opts.selected_color || ""}`;
      const found = prev.find((i) => i.product_id === product.product_id && (`${i.selected_date || ""}|${i.selected_size || ""}|${i.selected_color || ""}`) === key);
      if (found) {
        return prev.map((i) =>
          (i.product_id === product.product_id && (`${i.selected_date || ""}|${i.selected_size || ""}|${i.selected_color || ""}`) === key)
            ? { ...i, quantity: i.quantity + qty } : i
        );
      }
      return [...prev, {
        product_id: product.product_id, title: product.title,
        price: product.price, image_url: opts.color_image || product.image_url,
        type: product.type, category: product.category,
        selected_date: opts.selected_date || null,
        selected_size: opts.selected_size || null,
        selected_color: opts.selected_color || null,
        quantity: qty,
      }];
    });
  };
  const _keyOf = (i) => `${i.selected_date || ""}|${i.selected_size || ""}|${i.selected_color || ""}`;
  const remove = (pid, key = "") => setItems((p) => p.filter((i) => !(i.product_id === pid && _keyOf(i) === key)));
  const setQty = (pid, q, key = "") => setItems((p) =>
    p.map((i) => (i.product_id === pid && _keyOf(i) === key) ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
